import { useCallback } from 'react';
import { useRequest } from '@Hooks';
import { API } from '@Services';

export const useMarkSelectionsAsPaidForPaymentsExternal = () => {
  const [fetch, response] = useRequest<null>();

  const markSelectionsAsPaidForPaymentsExternal = useCallback(
    (fundId: number, selectionIds: number[]) =>
      fetch(API.paths.payments_external_mark_as_paid(fundId), 'post', {
        data: { selection_ids: selectionIds },
      }),
    [fetch],
  );

  return [markSelectionsAsPaidForPaymentsExternal, response] as const;
};
